import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import {
  FaWhatsapp, FaTractor, FaBolt, FaChartLine,
  FaTools, FaCloud, FaCoins, FaSeedling, FaCheck, FaMap, FaBars, FaTimes,
  FaArrowRight, FaArrowLeft, FaChevronDown,
  FaDatabase, FaMicrochip, FaFlask, FaTachometerAlt, FaGasPump,
} from 'react-icons/fa';
import '../styles/landingPage.scss';
import bootcamp from '../assets/bootcamp.png';
import dynasystem from '../assets/portfolio_tractorlab_bg.png';
import dynaop from '../assets/portfolio_bg.png';
import dynamap from '../assets/ksatwebgis.png';
import heroDiagnostico from '../assets/hero_bg.png';

const WHATSAPP_NUMBER = '5519995910565';
const GOOGLE_FORM_ACTION = 'https://docs.google.com/forms/d/e/1FAIpQLSe3fJ4ebXu8dhQWQh65gvyL-vRbxWwt8sy24fkr2gomXa8egg/formResponse';
const HIDDEN_IFRAME_NAME = 'lead-form-hidden-target';
const SLIDE_INTERVAL_MS = 6000;

const LANGUAGES = [
  { code: 'pt', flag: '🇧🇷', label: 'Português', href: '/' },
  { code: 'en', flag: '🇺🇸', label: 'English', href: '/en' },
  { code: 'es', flag: '🇪🇸', label: 'Español', href: '/es' },
];

const NAV_ITEMS = [
  { id: 'hero', label: 'Início' },
  { id: 'problem', label: 'Problema' },
  { id: 'portfolio', label: 'Soluções' },
  { id: 'services', label: 'Diagnóstico' },
  { id: 'about', label: 'Startup' },
  { id: 'blog', label: 'Blog', href: '/blog' },
];

const SLIDES = [
  {
    id: 1,
    tag: 'Sustentabilidade Agrícola',
    tagDot: '#8cff00',
    title: ['Toda operação agrícola gera dados.', 'Nós transformamos', 'esses dados em lucro.'],
    accentLine: 1,
    accentColor: '#03b352',
    subtitle: 'Conheça nossa linha de soluções para agricultura digital e saiba como identificamos pontos de economia nos custos de produção agrícola.',
    cta: { label: 'Conhecer Soluções', wa: 'Quero saber como as soluções da startup podem otimizar os custos da minha fazenda.' },
    badge: 'Eficiência Agrícola',
    image: heroDiagnostico,
  },
];

const PRODUCTS = [
  {
    id: 'dynasystem',
    status: 'Disponível',
    statusType: 'live',
    tag: 'Engenharia · Simulação de Tração',
    name: 'TractorLab — Simulação e Otimização de Frota Agrícola',
    description: 'Simule a interação solo-implemento-trator antes de ir a campo. O TractorLab aplica modelos clássicos para calcular força de tração, profundidade crítica de ruptura, patinagem ideal, eficiência trativa, consumo e lastro. Compare cenários e descubra a configuração mais eficiente para sua operação.',
    specs: [
      { icon: <FaTools />, label: 'Força, patinagem, eficiência, consumo e lastro ideal' },
      { icon: <FaTractor />, label: 'Comparação de cenários e ranking de combinações' },
      { icon: <FaChartLine />, label: 'Relatório técnico em PDF pronto para decisão' },
    ],
    image: dynasystem,
    action: { href: 'https://web-production-a2646b.up.railway.app/', label: 'Acessar plataforma (Demo)', icon: <FaArrowRight /> },
    accent: '#181818',
    extraAction: {
      label: 'Consultoria Técnica',
      wa: 'Quero orçar saber mais sobre a consultoria de otimização do conjunto solo-trator-implemento.',
      icon: <FaWhatsapp />,
    },
  },
  {
    id: 'dynamap',
    status: 'Disponível',
    statusType: 'live',
    tag: 'Física do Solo · Dinâmica de Água · Plataforma WebGIS',
    name: 'SoilCompact — Mapas de Infiltração e Zonas de Compactação',
    description: 'Diagnóstico hidro-físico de alta resolução. Mapeamos a condutividade hidráulica saturada (Ksat) para identificar zonas de manejo baseadas na capacidade real de infiltração, drenagem e retenção de água no perfil do solo.',
    specs: [
      { icon: <FaMap />, label: 'Predição via Machine Learning' },
      { icon: <FaFlask />, label: 'Atributo: física do solo' },
      { icon: <FaChartLine />, label: 'Geração de Zonas de Manejo' },
      { icon: <FaTools />, label: 'Plataforma WebGIS' },
    ],
    image: dynamap,
    action: { href: 'https://soilwater.vercel.app', label: 'Faça parte do teste piloto', icon: <FaArrowRight /> },
    extraAction: {
      label: 'Orçar Implementação WebGIS',
      wa: 'Quero orçar a implementação do WebGIS para mapeamento de infiltração e compactação.',
      icon: <FaWhatsapp />,
    },
    accent: '#181818',
  },
  {
    id: 'dynaop',
    status: 'Em processo de P&D',
    statusType: 'coming',
    tag: 'Deep Tech · IoT Embarcado',
    name: 'Otimização de Diesel em Tempo Real (Tratores Agrícolas)',
    description: 'Sistema embarcado que une curvas dinamométricas de motores diesel a algoritmos de otimização em tempo real. O operador recebe orientações contínuas para manter o trator no ponto de máxima eficiência no conjunto motor-solo-implemento, reduzindo consumo sem perder produtividade. Aplicação une o conceito de gamificação para aumentar a adesão dos operadores agrícolas.',
    specs: [
      { icon: <FaMicrochip />, label: 'Hardware + Software' },
      { icon: <FaBolt />, label: 'Economia estimada de até 30% por trator' },
      { icon: <FaDatabase />, label: 'Dados em tempo real' },
    ],
    image: dynaop,
    action: null,
    accent: '#4A8A28',
  },
];

const PROBLEMS = [
  {
    num: '01', icon: <FaBolt />, accent: '#4A8A28',
    title: 'Otimização de Diesel em Tratores',
    text: 'Tratores fora do ponto ótimo de torque consomem até 30% mais combustível. A adequação de marcha e rotação elimina esse desperdício.',
  },
  {
    num: '02', icon: <FaTools />, accent: '#8A6A00',
    title: 'Eficiência de Tração e Patinagem',
    text: 'Patinagem adequada eleva a eficiência de tração, resultando em menor compactação e menos gasto com diesel.',
  },
  {
    num: '03', icon: <FaMap />, accent: '#006080',
    title: 'Mapeamento Digital de Solos',
    text: 'Via machine learning, criamos mapas de infiltração e zonas de compactação, e esses dados são reutilizados nos outros sistemas.',
  },
  {
    num: '04', icon: <FaChartLine />, accent: '#B23A00',
    title: 'Decisões com Base em Dados',
    text: 'Sem monitoramento contínuo, ajustes ficam por conta da experiência. Dados em tempo real transformam intuição em precisão.',
  },
];

const SERVICES = [
    {
    ods: 'ODS 2',
    title: 'Promoção da Segurança Alimentar em Escala Mundial',
    text: 'Decisões orientadas por dados aumentam a previsibilidade da safra, sustentando a produção de alimentos em escala.',
    icon: <FaSeedling />,
    cta: 'Leia mais',
    wa: 'Quero fortalecer a segurança alimentar da minha produção',
    variant: 'primary',
    accent: '#3CA65E',
  },
  {
    ods: 'ODS 9',
    title: 'Industria, Inovação e Infraestrutura',
    text: 'Telemetria CAN em tempo real e dimensionamento trator-implemento reduzem tempo ocioso e elevam a produtividade da operação.',
    icon: <FaTractor />,
    cta: 'Leia mais',
    wa: 'Quero otimizar a eficiência do manejo agrícola da minha frota',
    variant: 'primary',
    accent: '#6BBF3C',
  },
  {
    ods: 'ODS 13',
    title: 'Combate as Mudanças Climáticas',
    text: 'Sistemas otimizados gastam menos diesel por hectare, reduzindo as emissões de CO2.',
    icon: <FaCloud />,
    cta: 'Leia mais',
    wa: 'Quero reduzir as emissões de CO2 da minha operação',
    variant: 'default',
    accent: '#4A90D9',
  },
  {
    ods: 'ODS 15',
    title: 'Vida Terrestre',
    text: 'Dimensionamento correto de infiltração e compactação no tráfego agrícola ajuda na promoção do uso sustentável dos ecossistemas.',
    icon: <FaCoins />,
    cta: 'Leia mais',
    wa: 'Quero reduzir os custos operacionais da minha frota',
    variant: 'default',
    accent: '#D9A441',
  },
];

const RESULT_ITEMS = [
  { icon: <FaTachometerAlt />, label: 'Monitoramento do Consumo de Diesel' },
  { icon: <FaGasPump />, label: 'Litros/ha Economizados' },
  { icon: <FaSeedling />, label: 'Eficiência no Consumo Hídrico' },
  { icon: <FaChartLine />, label: 'Dados Estruturados em Decisões' },
];

const useScrollReveal = () => {
  useEffect(() => {
    const elements = document.querySelectorAll('[data-reveal]');
    if (!elements.length) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -80px 0px' }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
};

const revealDelay = (index, step = 90) => ({ '--reveal-delay': `${index * step}ms` });

const LandingPage = () => {
  const [activeSection, setActiveSection] = useState('hero');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isHeaderScrolled, setIsHeaderScrolled] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slideDirection, setSlideDirection] = useState('next');
  const [isSlideAnimating, setIsSlideAnimating] = useState(false);
  const [leadStatus, setLeadStatus] = useState('idle');
  const slideTimerRef = useRef(null);

  const heroRef = useRef(null);
  const problemRef = useRef(null);
  const portfolioRef = useRef(null);
  const servicesRef = useRef(null);
  const aboutRef = useRef(null);

  const sectionRefs = useMemo(() => ({
    hero: heroRef,
    problem: problemRef,
    portfolio: portfolioRef,
    services: servicesRef,
    about: aboutRef,
  }), []);

  const hasMultipleSlides = SLIDES.length > 1;

  useScrollReveal();

  useEffect(() => {
    const onScroll = () => setIsHeaderScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isMenuOpen]);

  const goToSlide = useCallback((index, direction = 'next') => {
    if (isSlideAnimating || index === currentSlide) return;
    setSlideDirection(direction);
    setIsSlideAnimating(true);
    setTimeout(() => {
      setCurrentSlide(index);
      setIsSlideAnimating(false);
    }, 600);
  }, [isSlideAnimating, currentSlide]);

  const nextSlide = useCallback(
    () => goToSlide((currentSlide + 1) % SLIDES.length, 'next'),
    [currentSlide, goToSlide]
  );

  const prevSlide = useCallback(
    () => goToSlide((currentSlide - 1 + SLIDES.length) % SLIDES.length, 'prev'),
    [currentSlide, goToSlide]
  );

  const resetTimer = useCallback(() => {
    clearInterval(slideTimerRef.current);
    if (hasMultipleSlides) {
      slideTimerRef.current = setInterval(nextSlide, SLIDE_INTERVAL_MS);
    }
  }, [nextSlide, hasMultipleSlides]);

  useEffect(() => {
    if (!hasMultipleSlides) return undefined;
    slideTimerRef.current = setInterval(nextSlide, SLIDE_INTERVAL_MS);
    return () => clearInterval(slideTimerRef.current);
  }, [nextSlide, hasMultipleSlides]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPos = window.scrollY + 100;
      for (const [section, ref] of Object.entries(sectionRefs)) {
        if (ref.current && ref.current.offsetTop <= scrollPos) {
          setActiveSection(section);
        }
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [sectionRefs]);

  const scrollToSection = useCallback((id) => {
    sectionRefs[id]?.current?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  }, [sectionRefs]);

  const openWhatsApp = useCallback((message) => {
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');
  }, []);

  const handleLeadSubmit = useCallback((e) => {
    setLeadStatus('submitting');
    const form = e.currentTarget;
    window.setTimeout(() => {
      setLeadStatus('success');
      form.reset();
    }, 600);
  }, []);

  const slide = SLIDES[currentSlide];

  return (
    <div className="lp">
      <header className={`lp__header ${isHeaderScrolled || isMenuOpen ? 'lp__header--scrolled' : ''}`}>
        <div className="lp__header-inner">
          <a className="lp__logo" href="/">
            <FaTractor aria-hidden="true" /><span>DYNA<em>TECH</em></span>
          </a>

          <nav className={`lp__nav ${isMenuOpen ? 'lp__nav--open' : ''}`} aria-label="Navegação principal">
            {NAV_ITEMS.map(({ id, label, href }) => (
              href ? (
                <a key={id} href={href} className="lp__nav-link">{label}</a>
              ) : (
                <button
                  key={id}
                  type="button"
                  className={`lp__nav-link ${activeSection === id ? 'lp__nav-link--active' : ''}`}
                  onClick={() => scrollToSection(id)}
                >
                  {label}
                </button>
              )
            ))}

            <div className="lp__lang-switcher">
              {LANGUAGES.map(({ code, flag, label, href }) => (
                <button
                  key={code}
                  type="button"
                  title={label}
                  aria-label={label}
                  onClick={() => { window.location.href = href; }}
                >
                  {flag}
                </button>
              ))}
            </div>

            <button
              type="button"
              className="lp__nav-cta"
              onClick={() => openWhatsApp('Gostaria de saber como a DynaTech pode otimizar minha operação.')}
            >
              <FaWhatsapp aria-hidden="true" /> Contato
            </button>
          </nav>

          <button
            type="button"
            className="lp__menu-btn"
            aria-label={isMenuOpen ? 'Fechar menu' : 'Abrir menu'}
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen((open) => !open)}
          >
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </header>

      <section className="lp__hero" ref={heroRef}>
        <div
          className={`lp__hero-bg ${isSlideAnimating ? `lp__hero-bg--${slideDirection}` : ''}`}
          style={{ backgroundImage: `url(${slide.image})` }}
          role="img"
          aria-label={slide.badge}
        />
        <div className="lp__hero-overlay" />

        <div className={`lp__hero-content ${isSlideAnimating ? 'lp__hero-content--exit' : 'lp__hero-content--enter'}`}>
          <h1 className="lp__hero-title">
            {slide.title.map((line, i) => (
              <span key={line} style={{ animationDelay: `${i * 0.08}s` }}>
                {i === slide.accentLine ? <em style={{ color: slide.accentColor }}>{line}</em> : line}
              </span>
            ))}
          </h1>

          <p className="lp__hero-sub">{slide.subtitle}</p>

          <div className="lp__hero-actions">
            <button
              type="button"
              className="lp__btn lp__btn--primary"
              style={{ background: slide.accentColor, color: '#0A1A0B' }}
              onClick={() => openWhatsApp(slide.cta.wa)}
            >
              <FaWhatsapp aria-hidden="true" /> {slide.cta.label}
            </button>
            <button type="button" className="lp__btn lp__btn--outline-light" onClick={() => scrollToSection('portfolio')}>
              Ver Soluções <FaArrowRight aria-hidden="true" />
            </button>
          </div>

          <div className="lp__hero-badge">
            <span style={{ color: slide.accentColor }}>✦</span> {slide.badge}
          </div>
        </div>

        {hasMultipleSlides && (
          <>
            <div className="lp__carousel-controls">
              <button
                type="button"
                className="lp__carousel-arrow"
                aria-label="Slide anterior"
                onClick={() => { prevSlide(); resetTimer(); }}
              >
                <FaArrowLeft />
              </button>
              <div className="lp__carousel-dots">
                {SLIDES.map((s, i) => (
                  <button
                    key={s.id}
                    type="button"
                    aria-label={`Ir para o slide ${i + 1}`}
                    className={`lp__carousel-dot ${i === currentSlide ? 'lp__carousel-dot--active' : ''}`}
                    style={i === currentSlide ? { background: slide.accentColor } : undefined}
                    onClick={() => { goToSlide(i, i > currentSlide ? 'next' : 'prev'); resetTimer(); }}
                  />
                ))}
              </div>
              <button
                type="button"
                className="lp__carousel-arrow"
                aria-label="Próximo slide"
                onClick={() => { nextSlide(); resetTimer(); }}
              >
                <FaArrowRight />
              </button>
            </div>

            <div className="lp__carousel-counter">
              <span style={{ color: slide.accentColor }}>{String(currentSlide + 1).padStart(2, '0')}</span>
              <span className="lp__carousel-counter-sep" />
              <span>{String(SLIDES.length).padStart(2, '0')}</span>
            </div>
          </>
        )}

        <button type="button" className="lp__scroll-hint" aria-label="Rolar para a próxima seção" onClick={() => scrollToSection('problem')}>
          <FaChevronDown />
        </button>
      </section>

      <section className="lp__problem" ref={problemRef}>
        <div className="lp__container">
          <div className="lp__problem-intro">
            <div>
              <h2 className="lp__section-title">
                4 Pilares de <br />
                <span>Otimização Agrícola</span>
              </h2>
            </div>
            <p className="lp__section-sub">
              Cada operação agrícola carrega perdas silenciosas. Identificá-las é o primeiro passo para transformar custo em rentabilidade.
            </p>
          </div>

          <div className="lp__problem-grid">
            {PROBLEMS.map((card) => (
              <div key={card.num} className="lp__problem-card" style={{ '--card-accent-color': card.accent }}>
                <span className="lp__problem-icon" style={{ color: card.accent }}>{card.icon}</span>
                <h3>{card.title}</h3>
                <p>{card.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="lp__portfolio" ref={portfolioRef}>
        <div className="lp__container">
          <div className="lp__portfolio-layout">
            <div className="lp__portfolio-intro">
              <div className="lp__eyebrow">A Plataforma DynaTech</div>
              <h2 className="lp__section-title">
                Soluções digitais para uma tomada de decisão com <span>redução de custos</span>
              </h2>
              <p className="lp__section-sub">
                Uma plataforma completa que coleta, analisa e transforma dados em inteligência para você tomar decisões melhores.
              </p>
              <button type="button" className="lp__btn lp__btn--primary" onClick={() => scrollToSection('portfolio')}>
                Ver plataforma <FaArrowRight aria-hidden="true" />
              </button>
            </div>

            <div className="lp__portfolio-grid">
              {PRODUCTS.map((product) => (
                <article key={product.id} className="lp__product-card">
                  <div className="lp__product-card-image">
                    <img src={product.image} alt={product.name} loading="lazy" decoding="async" />
                  </div>

                  <div className="lp__product-card-body">
                    <h3>{product.name}</h3>
                    <p>{product.description}</p>

                    <ul className="lp__product-card-checklist">
                      {product.specs.map((spec) => (
                        <li key={spec.label}>
                          <FaCheck style={{ color: product.accent }} aria-hidden="true" />
                          {spec.label}
                        </li>
                      ))}
                    </ul>

                    {product.action && (
                      <a
                        href={product.action.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="lp__btn lp__btn--product"
                        style={{ background: product.accent, color: '#fff' }}
                      >
                        {product.action.label} {product.action.icon}
                      </a>
                    )}

                    {product.extraAction && (
                      <button
                        type="button"
                        className="lp__btn lp__btn--product"
                        style={{ background: '#F5A623', color: '#1A1A1A' }}
                        onClick={() => openWhatsApp(product.extraAction.wa)}
                      >
                        {product.extraAction.icon} {product.extraAction.label}
                      </button>
                    )}

                    {!product.action && !product.extraAction && (
                      <button type="button" className="lp__btn lp__btn--soon" disabled>
                        <span className="lp__btn-soon-dot" /> Em breve
                      </button>
                    )}
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="lp__results">
        <div className="lp__container">
          <div className="lp__results-inner">
            <div className="lp__results-text" data-reveal>
              <div className="lp__eyebrow">Resultados</div>
              <h2 className="lp__section-title">
                Impacto mensurável <br /><span>em cada operação.</span>
              </h2>
              <p className="lp__section-sub">
                Dados que transformam a gestão da sua fazenda em decisões precisas e lucrativas.
              </p>
            </div>

            <div className="lp__results-cards">
              {RESULT_ITEMS.map((item, index) => (
                <div key={item.label} className="lp__result-card" style={revealDelay(index, 80)} data-reveal>
                  <span className="lp__result-icon">{item.icon}</span>
                  <h3>{item.label}</h3>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="lp__services" ref={servicesRef}>
        <div className="lp__container">
          <div className="lp__services-header">
            <div className="lp__eyebrow lp__eyebrow--light">Diagnóstico de Alto Impacto</div>
            <h2 className="lp__section-title lp__section-title--light">
              Nossa Missão e Valores Estão alinhadas com as<br />
              <em>Metas Mundiais</em> da Agricultura Moderna
            </h2>
            <p className="lp__section-sub lp__section-sub--light">
              Metodologia estruturada de engenharia agrícola para transformar dados de campo em decisões concretas de melhoria operacional.
            </p>
          </div>

          <div className="lp__services-grid">
            {SERVICES.map((svc) => (
              <div key={svc.title} className={`lp__service-card lp__service-card--${svc.variant}`}>
                <span className="lp__service-ods">{svc.ods}</span>
                <span className="lp__service-icon" style={{ color: svc.accent }}>{svc.icon}</span>
                <h3 className="lp__service-title">{svc.title}</h3>
                <p className="lp__service-text">{svc.text}</p>
                <button type="button" className="lp__service-cta" onClick={() => openWhatsApp(svc.wa)}>
                  {svc.cta} <FaArrowRight aria-hidden="true" />
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="lp__about" ref={aboutRef}>
        <div className="lp__container">
          <div className="lp__about-grid">
            <div className="lp__about-image">
              <div className="lp__about-main-img">
                <img src={bootcamp} alt="Time DynaTech durante o bootcamp Sebrae for Startups" loading="lazy" decoding="async" />
              </div>
            </div>

            <div className="lp__about-content">
              <div className="lp__eyebrow">A Startup</div>
              <h2 className="lp__section-title">
                DynaTech - Ecossistema AgTech<br />
                <span>com Rigor Científico</span>
              </h2>
              <p>
                A DynaTech nasceu da interseção entre pesquisa acadêmica em mecanização
                agrícola, machine learning, física do solo e desenvolvimento de tecnologia de fronteira. Através da engenharia de software, unimos o conhecimento do domínio do problema agrícola e desenvolvemos sistemas embarcados e aplicativos (mobile e web), cobrindo todo o ciclo de desenvolvimento de produto para agricultura digital.
              </p>

              <div className="lp__about-badges">
                <div className="lp__about-badge">
                  <div>
                    <strong>André Luiz Bandeli Júnior (Founder)</strong>
                    <span>
                      Graduando em Engenharia Agrícola, Unicamp | Técnico Mecatrônico, COTUCA/UNICAMP | Software Engineering | Linkedin: <a href="https://linkedin.com/in/andrebandeli/" target="_blank" rel="noopener noreferrer">/andrebandeli</a> | Pesquisas: <a href="https://www.researchgate.net/profile/Andre-Bandeli-Junior" target="_blank" rel="noopener noreferrer">Researchgate</a>
                    </span>
                    <br /><span>Campinas, São Paulo. Brasil.</span>
                  </div>
                </div>
                <div className="lp__about-badge">
                  <div>
                    <strong>Sebrae for Startups | IPT | ABStartups</strong>
                    <span>Validação do Modelo de Negócios | Finalistas — Spark 2025 | Classificação Deeptech | Inovação de Fronteira</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="lp__cta-strip" id="diagnostico">
        <div className="lp__container">
          <h2 data-reveal>Não deixe o prejuízo se tornar<br /><span>o seu próximo custo fixo.</span></h2>
          <p data-reveal style={revealDelay(1, 60)}>Descubra quanto você pode economizar com nossa solução de otimização agrícola.</p>

          <div className="wg-lead__form lp__cta-strip-form" data-reveal style={revealDelay(2, 60)}>
            {leadStatus === 'success' ? (
              <div className="wg-lead__form-success" role="status">
                <FaCheck aria-hidden="true" />
                <div>
                  <strong>Recebemos seus dados!</strong>
                  <p>Nossa equipe vai analisar e entrar em contato em breve.</p>
                </div>
              </div>
            ) : (
              <form action={GOOGLE_FORM_ACTION} method="POST" target={HIDDEN_IFRAME_NAME} onSubmit={handleLeadSubmit}>
                <div className="wg-lead__form-row">
                  <input name="entry.1525905038" type="text" placeholder="Nome completo" required disabled={leadStatus === 'submitting'} />
                  <input name="entry.613404927" type="email" placeholder="E-mail" required disabled={leadStatus === 'submitting'} />
                </div>

                <div className="wg-lead__form-row">
                  <input name="entry.1648254899" type="tel" placeholder="WhatsApp (com DDD)" required disabled={leadStatus === 'submitting'} />
                  <input name="entry.1423683715" type="text" placeholder="Fazenda / município" required disabled={leadStatus === 'submitting'} />
                </div>

                <div className="wg-lead__form-row">
                  <input name="entry.1441935685" type="number" placeholder="Área total (ha)" required min="1" disabled={leadStatus === 'submitting'} />
                  <select name="entry.780299442" required disabled={leadStatus === 'submitting'}>
                    <option value="">Tenho interesse em...</option>
                    <option value="Otimização de diesel">Otimização de diesel</option>
                    <option value="Tração trator-implemento">Tração trator-implemento</option>
                    <option value="Mapeamento de solo">Mapeamento de solo</option>
                    <option value="Ainda não sei">Ainda não sei, quero uma avaliação</option>
                  </select>
                </div>

                <button type="submit" className="wg-btn wg-btn--primary wg-btn--block" disabled={leadStatus === 'submitting'}>
                  {leadStatus === 'submitting' ? 'Enviando...' : 'Enviar diagnóstico'}
                </button>
              </form>
            )}
          </div>
        </div>

        <iframe name={HIDDEN_IFRAME_NAME} title="Envio de formulário" style={{ display: 'none' }} />
      </section>

      <footer className="lp__footer">
        <div className="lp__container">
          <div className="lp__footer-grid">
            <div className="lp__footer-brand">
              <a className="lp__logo" href="/"><FaTractor aria-hidden="true" /><span>DYNA<em>TECH</em></span></a>
              <p>Otimização agrícola com base científica. Do campo à tomada de decisão.</p>
            </div>

            <div className="lp__footer-col">
              <h4>Soluções</h4>
              <a href="/blog/dynaoperator">Otimizador de Trator Agrícola</a>
              <a href="https://dynasystem.onrender.com/" target="_blank" rel="noopener noreferrer">TractorLab</a>
              <a href="/blog/dynamap">SoilCompact</a>
            </div>

            <div className="lp__footer-col">
              <h4>Empresa</h4>
              <a href="/about">Quem Somos</a>
              <a href="/blog">Blog DynaTech</a>
            </div>

            <div className="lp__footer-col">
              <h4>Contato</h4>
              <button type="button" className="lp__footer-col-link-btn" onClick={() => openWhatsApp('Olá, gostaria de mais informações sobre a DynaTech.')}>
                <FaWhatsapp aria-hidden="true" /> WhatsApp
              </button>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">Linkedin</a>
              <a href="mailto:agritech.dyna@gmail.com">agritech.dyna@gmail.com</a>
            </div>
          </div>

          <div className="lp__footer-bottom">
            <p>© 2026 DynaTech · AgTech de Otimização Agrícola · Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;